import React from "react";
import { components as c } from "@/components";
import { useSelectStaffByOrganisationId } from "../../profile/api/selectStaffByOrganisatonId";
import { OptionT } from "../../../types";
import InviteForm from "../../invite/components/InviteForm";

const ContactPersonComboBox = (
    { organisationId }: { organisationId: string },
) => {
    const { data: staff } = useSelectStaffByOrganisationId(organisationId);

    return (
        <c.fc.ComboBox
            options={staff?.map(
                (person) => ({
                    label: person.name,
                    value: person.user_id,
                }),
            ) as OptionT[]}
            name="contact_id"
            label="Contact Person"
            description="Someone the patient can contact if they want further contact with the clinic. This email will be shared with the patient."
            placeholder="Select a contact"
            addOption={<InviteForm />}
        />
    );
};

export default ContactPersonComboBox;
